import React from "react";
import styles from "./style.module.scss";
import girlAvatarVideo from "../../../Utils/Assets/Videos/girlAvatarVideo.mp4";

const AboutHeader = () => {
    return (
        <div className={styles.headerWrapper}>
            <div className={styles.bgImageheaderAbout}>
                <video
                    className={styles.bgVideo}
                    src={girlAvatarVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <div className={styles.bgOverlay}></div>
            </div>
            <div className={styles.content}>
                <button className={styles.aboutAsButton} name="aboutAsButton">
                    About us
                </button>
                <div className={styles.aboutAsContent}>
                    <p className={styles.aboutAsTitle}>
                        MeetUsVR: A Movement, Not <br /> Just a Platform
                    </p>
                    <p className={styles.aboutAsdes}>
                        MeetUsVR is redefining how people connect, work, and
                        thrive in the virtual world Powered by blockchain, we
                        blend.
                    </p>
                    <p className={styles.aboutAsdes}>
                        immersive experiences with real economic
                        opportunities—allowing users to chat, host events, and
                        earn in the metaverse.
                    </p>
                </div>
                <div className="">
                    <button className={styles.JointBtn} >
                        Join the Movement
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AboutHeader;
